import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modalizer from 'components/modalizer/modalizer'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import generalActions from 'redux/actions/generalActions'
import AdminOnboardingAddUserForm from './form/admin_onboarding_add_user_form'
import adminOnboardingActions from 'redux/actions/adminOnboardingActions'

class AdminOnboardingAddUserModal extends Component {
	render() {
		return (
			<Modalizer width='500px' closeAction={() => this.props.actions.closeModal(this.props.modalName)}>
				<AdminOnboardingAddUserForm
					initialValues={{
						firstName: '',
						lastName: '',
						email: '',
					}}
					addUser={this.props.actions.addUserAction}
					formSubmitHandler = {this.formAddUserSubmitHandler}
				/>
			</Modalizer>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
		addUserAction: adminOnboardingActions.addUser,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(AdminOnboardingAddUserModal)
